import React from "react";
import styles from './Breadcrumbs.module.scss';
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

const Breadcrumbs = ({ breadcrumbs }) => {
  return (
    <nav className={styles.breadcrumbs}>
      <ol>
        {breadcrumbs.map((breadcrumb, index) => {
          const isLast = index === breadcrumbs.length - 1;

          return (
            <li
              key={breadcrumb.label}
              className={`breadcrumb-item ${isLast ? 'active' : ''}`}
              aria-current={isLast ? 'page' : undefined}
            >
              {breadcrumb.path ? (
                <Link to={breadcrumb.path}>{breadcrumb.label}</Link>
              ) : (
                <span>{breadcrumb.label}</span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.string,
    })
  ).isRequired,
};

export default Breadcrumbs;